import { Box, TextField, Typography } from "@mui/material";

const fields = [
  {
    labelFunc: (currency) => `General Labor Costs per day (${currency})`,
    state: 'laborCosts',
    setState: 'setLaborCosts'
  },
  {
    labelFunc: (currency) => `Burn Supervisor Costs per day (${currency})`,
    state: 'burnSupervisorCosts',
    setState: 'setBurnSupervisorCosts'
  },
  {
    labelFunc: (currency) => `Capital Cost per kiln (${currency})`,
    state: 'capitalCosts',
    setState: 'setCapitalCosts'
  },
  {
    labelFunc: (currency) => `Other Costs per day (${currency})`,
    state: 'otherCosts',
    setState: 'setOtherCosts'
  },
];

const Step3Form = (props) => {
  const handleChange = (setter) => ({ target: { value } }) => {
    setter(value);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', px: 3, gap: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="h6" gutterBottom>
          OPEX and CAPEX Information
        </Typography>
      </Box>
      {fields.map((field, index) => {
        const { labelFunc, state, setState } = field
        return (
          <Box key={index}>
            <TextField
              id={state}
              required
              fullWidth
              label={labelFunc(props.currency)}
              variant="outlined"
              value={props[state]}
              onChange={handleChange(props[setState])}
            />
          </Box>
        )
      })}
    </Box>
  );
};

export default Step3Form;
